export default {
  nav: {
    play: '开始游戏',
    about: '关于',
    features: '特性',
    tips: '攻略',
    faq: '常见问题'
  },
  hero: {
    title: '怪物生存者',
    subtitle: '终极免费在线Roguelike生存游戏',
    playButton: '立即开玩',
    learnButton: '了解更多'
  },
  about: {
    title: '关于怪物生存者',
    description1: '怪物生存者是一款刺激的Roguelike生存游戏，你需要与无尽的怪物浪潮战斗。',
    description2: '选择你的角色，升级你的能力，看看你能存活多久！',
    description3: '独特的武器组合和角色成长系统，每次游戏体验都不同。',
    description4: '直接在浏览器中免费游玩 - 无需下载！'
  },
  features: {
    title: '游戏特色',
    characters: {
      title: '独特角色',
      description: '选择多个角色，每个角色都有自己的特殊能力和玩法。'
    },
    weapons: {
      title: '武器进化',
      description: '组合不同的武器和道具，创造强大的进化版本。'
    },
    gameplay: {
      title: '无尽动作',
      description: '在程序生成的关卡中面对越来越困难的怪物浪潮。'
    }
  },
  tips: {
    title: '游戏攻略',
    tip1: {
      title: '掌握移动',
      description: '保持机动性，学会边攻击边风筝敌人。'
    },
    tip2: {
      title: '规划构建',
      description: '选择与你的角色和玩法相辅相成的升级。'
    },
    tip3: {
      title: '快速升级',
      description: '迅速收集经验宝石，保持领先于难度曲线。'
    }
  },
  faq: {
    title: '常见问题',
    q1: {
      question: '怪物生存者是免费的吗？',
      answer: '是的，怪物生存者完全免费，可以直接在浏览器中游玩。无需下载或安装！'
    },
    q2: {
      question: '怎么玩怪物生存者？',
      answer: '使用WASD移动，空格攻击，E键使用特殊能力。收集经验升级并选择升级来变得更强！'
    },
    q3: {
      question: '怪物生存者有什么特别之处？',
      answer: '怪物生存者具有独特的角色成长、武器进化系统和程序生成关卡。每次游戏都带来不同的体验！'
    }
  },
  newsletter: {
    title: '保持更新',
    description: '订阅我们的通讯，获取更新、攻略和特别活动信息！',
    placeholder: '输入你的邮箱',
    button: '订阅'
  },
  related: {
    title: '你可能喜欢的类似游戏',
    description: '看看这些其他优秀的Roguelike生存游戏！'
  },
  footer: {
    quickLinks: '快速链接',
    social: '关注我们',
    copyright: '© 2024 怪物生存者。保留所有权利。'
  },
  reviews: {
    title: '游戏评价',
    rating: '评分',
    commentPlaceholder: '分享你的游戏体验...',
    submit: '提交评价',
    ratingRequired: '请选择评分',
    commentRequired: '请输入评价内容',
    commentTooLong: '评价内容不能超过500字',
    invalidRating: '请选择1-5星评分',
    submitSuccess: '评价提交成功',
    loadMore: '加载更多评价',
    loading: '正在加载评价...',
    noReviews: '还没有评价，来分享你的想法吧！',
    error: {
      loadFailed: '加载评价失败，请稍后再试',
      submitFailed: '提交评价失败，请稍后再试',
      networkError: '网络错误，请检查网络连接',
      permissionDenied: '没有权限执行此操作',
      rateLimitExceeded: '操作太频繁，请稍后再试'
    }
  },
  loading: {
    tip1: '正在召唤怪物...',
    tip2: '正在准备武器...',
    tip3: '正在加载地图...',
    tip4: '即将开始冒险...'
  },
  time: {
    justNow: '刚刚',
    minutesAgo: '{minutes}分钟前',
    hoursAgo: '{hours}小时前',
    daysAgo: '{days}天前',
    longAgo: '很久以前'
  }
} 